<template>
  <div id="app">
    <router-view />
    <alerts></alerts>

    <Tour />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import Alerts from '@/modules/shared/components/Alerts'
import Tour from '@/modules/shared/components/Tour'

import { scrollerMixin } from '@/mixins'

import {
  dealTypes,
  practiceTypes,
  loanTypes,
  loanRepaymentTypes,
  creditScores,
  lenderFeatures,
  deadlineSpeeds,
} from '@/data/questions'

export default {
  name: 'App',
  mixins: [scrollerMixin],
  components: {
    Alerts,
    Tour,
  },

  computed: {
    ...mapState('feathers', {
      client: 'client',
    }),
    ...mapState('authStore', {
      userData: 'userData',
    }),
  },

  async created () {
    await this.authenticateFromStorage()

    this.setQuestions({
      dealTypes,
      practiceTypes,
      loanTypes,
      loanRepaymentTypes,
      creditScores,
      lenderFeatures,
      deadlineSpeeds,
    })
  },

  methods: {
    ...mapActions('feathers', ['logout']),
    ...mapActions('questionnaireStore', ['setQuestions']),
    ...mapMutations('authStore', ['CLEAR_USER_DATA', 'SET_USER_DATA']),

    async authenticateFromStorage () {
      if (!(await this.client.authentication.getAccessToken())) return

      try {
        const response = await this.client.reAuthenticate()
        if (response && response.user) this.SET_USER_DATA(response.user)
      } catch (error) {
        if (error.name === 'NotAuthenticated') {
          this.CLEAR_USER_DATA()
          this.$router.push({ name: 'Home' })
        } else if (error.data && error.data.type === 'requirePasswordReset') {
          this.addWarningAlert(error.message)
          await this.logout()
          this.CLEAR_USER_DATA()
          this.$router.push({ name: 'Home' })
        } else {
          this.addAlert({
            type: 'error',
            message: `There was an error when trying to reauthenticate your session: ${error.message}`,
          })
        }
      }
    },
  },
}
</script>
